// extracted by mini-css-extract-plugin
export default {"disclaimer":"FleetTermsAndConditionsModal_disclaimer__AdY0k","link":"FleetTermsAndConditionsModal_link__VLXX8"};